var shopifyHeader = document.querySelector("[data-header]");
var shopifyHeaderHeight = shopifyHeader.offsetHeight;

document.documentElement.style.setProperty('--announcement-bar', "0px");
document.documentElement.style.setProperty('--header-height', shopifyHeaderHeight+"px");

var announcementBar = document.getElementById("shopify-section-announcement-bar");
if (announcementBar != undefined) {
    var announcementBarHeight = announcementBar.offsetHeight;
    document.documentElement.style.setProperty('--announcement-bar', announcementBarHeight + "px");
}

var headerTransparent = document.querySelector(".header--transparent");
if (headerTransparent != undefined) var isIndex = true
else var isIndex = false;

var logoMobile = document.querySelector(".header__logo-mobile");
var logoMobileMini = document.querySelector(".header__logo-mobile-mini");

// Open / Close mobile sidemenu eventlistener
var headerHamburger = document.querySelector("[data-header-hamburger]");
var headerCross = document.querySelector("[data-header-cross]");
var headerSidemenu = document.querySelector("[data-header-sidemenu]");
var headerSidemenuBackground = document.querySelector("[data-header-sidemenu-background]");
if (headerHamburger != undefined) {
    headerHamburger.addEventListener("click", () => {
        openSidemenu();
    })
}
if (headerCross != undefined) {
    headerCross.addEventListener("click", () => {
        closeSidemenu();
    });
}
if (headerSidemenuBackground != undefined) {
    headerSidemenuBackground.addEventListener("click", () => {
        closeSidemenu();
    });
}
// Open / Close mobile sidemenu function
function openSidemenu() {
    if (logoMobileMini != undefined) {
        logoMobile.classList.add("hide");
        logoMobileMini.classList.remove("hide");
    }

    if (headerSidemenuBackground != undefined) headerSidemenuBackground.classList.remove("hide");
    headerHamburger.classList.add("hide");

    if (announcementBar != undefined) announcementBar.classList.add("hide");

    shopifyHeader.classList.remove("header--transparent");
    shopifyHeader.classList.add("header--fixed");

    document.body.style.height = "100vh";
    document.body.style.overflow = "hidden";

    if (headerSidemenu != undefined) {
        headerSidemenu.classList.remove("hide");
        setTimeout(() => {
            headerSidemenu.classList.add("header--sidemenu-open");
            document.querySelector(".header--mobile").style.background = "#f7f7f7";
        }, 100);
    }
}
function closeSidemenu() {
    if (logoMobileMini != undefined) {
        logoMobileMini.classList.add("hide");
        logoMobile.classList.remove("hide");
    }
    if (headerSidemenu != undefined) {
        headerSidemenu.classList.remove("header--sidemenu-open");
        document.body.style.height = "auto";
        document.body.style.overflow = "auto";

        shopifyHeader.classList.remove("header--fixed");

        if (headerSidemenuBackground != undefined) headerSidemenuBackground.classList.add("hide");
        headerHamburger.classList.remove("hide");
        if (announcementBar != undefined) announcementBar.classList.remove("hide");
        setTimeout(() => {
            headerSidemenu.classList.add("hide");
        }, 600);
    }
}

const linkLastMenus = document.querySelectorAll('.megamenu-mobile__body .faq__question-title.megamenu-mobile__childlink-link');
const lastMenus = document.querySelectorAll('.megamenu-mobile__body .faq__question-answer-container.toggle-container');

linkLastMenus.forEach((linkLastMenu, index) => {
    linkLastMenu.addEventListener('click', e => {
        lastMenus[index].classList.toggle('active');
        linkLastMenu.classList.toggle('active');
    });
});

// const newsletterPopup = document.querySelector('.header__nav-li.newsletter-link');
// const newsletterContent = document.querySelector("#newsletterContent");
//
// const toggleNewsletter = (add) => {
//     if (add) {
//         newsletterContent.classList.add('active');
//     } else {
//         newsletterContent.classList.remove('active');
//     }
// };
//
// const events = ['mouseover', 'mouseout'];
//
// events.forEach(event => {
//     newsletterPopup.addEventListener(event, (e) => toggleNewsletter(e.type === 'mouseover'));
//     newsletterContent.addEventListener(event, (e) => toggleNewsletter(e.type === 'mouseover'));
// });


var lastScrollTopPosition = 0;

window.addEventListener('scroll', function() {
    var scrollTop = document.documentElement.scrollTop;

    if (scrollTop > 180) {
        if (isIndex && shopifyHeader.classList.contains("header--transparent")) {
            shopifyHeader.classList.remove("header--transparent");
            document.querySelector(".header--mobile").style.background = "white";
        }
    } else if (scrollTop < 80) {
        if (isIndex && !shopifyHeader.classList.contains("header--transparent")) {
            shopifyHeader.classList.add("header--transparent");
            document.querySelector(".header--mobile").style.background = "transparent";
        }
    }
    lastScrollTopPosition = scrollTop;
});

// Show / Hide search bar
var searchButtons = document.querySelectorAll("[data-header-search-button]");
var searchBars = document.querySelectorAll("[data-header-search]");
var searchClose = document.querySelectorAll("[data-header-search-close]");
var openSearch = document.querySelector('#openSearch');
var closeSearch = document.querySelector('#closeSearch');
// Show search bar
searchButtons.forEach((button) => {
    var buttonData = button.dataset.headerSearchButton;
    button.addEventListener("click", () => {

        document.querySelectorAll("[data-header-search]").forEach((bar) => {
            if (bar.dataset.headerSearch == buttonData){
                openSearch.style.display = "none";
                closeSearch.style.display = "block";
                searchBars.forEach(searchBar => {
                    searchBar.classList.add("active");
                })
                bar.classList.add("active");
                bar.querySelector("input").focus();
                if (document.querySelector('.aa-Input') != null) {
                    setTimeout(function() {
                        document.querySelector('.aa-Input').focus()
                    }, 800);
                }
            }
        })
    })
});
// add language to each result's url
document.querySelector('[data-header-search-button]').addEventListener('click', function(){
    setTimeout(() => {addLanguageToUrl()}, 1000);
})

if (document.querySelectorAll('#autocomplete-0-input').length > 0) {
    var searchInput = document.querySelector('#autocomplete-0-input')
    searchInput.addEventListener('input', function(){
        setTimeout(() => {addLanguageToUrl()}, 50);
    })
}

function addLanguageToUrl() {
    var searchResult = document.querySelector('.aa-PanelLayout');
    var searchResultUrls = searchResult.querySelectorAll('a');
    var currentUrl = window.location.href;
    if (currentUrl.indexOf("/fr") > -1) {
        for (let i = 0; i < searchResultUrls.length; i++) {
            var url = searchResultUrls[i];
            var urlLink = url.getAttribute('href');
            if (urlLink.indexOf("/fr") === -1) {
                urlLink = 'https://www.bonparfumeur.com/fr' + urlLink;
                url.setAttribute('href', urlLink)
            }
        }
    } else if (currentUrl.indexOf("/en-gb") > -1) {
        for (let i = 0; i < searchResultUrls.length; i++) {
            var url = searchResultUrls[i];
            var urlLink = url.getAttribute('href');
            if (urlLink.indexOf("/en-gb") === -1) {
                urlLink = 'https://www.bonparfumeur.com/en-gb' + urlLink;
                url.setAttribute('href', urlLink)
            }
        }
    }
}

// Hide search bar
searchClose.forEach((close) => {
    var closeData = close.dataset.headerSearchClose;
    close.addEventListener("click", () => {
        document.querySelectorAll("[data-header-search]").forEach((bar) => {
            if (bar.dataset.headerSearch == closeData){
                openSearch.style.display = "block";
                closeSearch.style.display = "none";
                bar.classList.remove("active");
                if (document.querySelector('.aa-Panel') != null) {
                    document.querySelector('.aa-Panel').remove();
                }
                if (document.querySelector('.aa-Input') != null) {
                    document.querySelector('.aa-Input').value = "";
                }
            }
        })
    })
});

var liMegamenus = document.querySelectorAll(".header__nav-li--megamenu");
liMegamenus.forEach((menu) => {
    menu.addEventListener("mouseenter", () => {
        if (isIndex && shopifyHeader.classList.contains("header--transparent")) {
            shopifyHeader.classList.remove("header--transparent");
        }
    });
});

// Languages selector
var selectedLanguage = document.querySelectorAll(".desktop-language-selector");
selectedLanguage.forEach((sl) => {
    var button = sl.querySelector('.language-selector-button')
    button.addEventListener("click", (el) => {
        var languages = sl.querySelector(".language-selector-list");
        languages.classList.toggle('active');
    });
})

// Show sidemenu megamenu mobile
var sidemenuTitles = document.querySelectorAll("[data-sidemenu-title]");
// var sidemenuMM = document.querySelectorAll("[data-sidemenu-mm]");

sidemenuTitles.forEach((title) => {
    title.addEventListener("click", () => {
        var t = title.dataset.sidemenuTitle;
        document.querySelector("[data-sidemenu-mm='"+t+"']").classList.add("active");
    })
})

var megamenuMobileClose = document.querySelectorAll("[data-mm-mobile-close]");
megamenuMobileClose.forEach((close) => {
    close.addEventListener("click", () => {
        document.querySelectorAll("[data-sidemenu-mm]").forEach((mm) => {
            mm.classList.remove("active");
        })
    })
});

// Delete value form search input
document.querySelector('.delete-search-form').addEventListener('click', () => {
    const searchInput = document.querySelector('form input[type="search"]');
    if (searchInput) {
        searchInput.value = ''; // Vide le contenu de l'input
    }
})